export default "__VITE_ASSET__0deab159__"